// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useLocation, useNavigate } from "react-router-dom";
// import { API_BASE_URL, API_DOMAIN } from "../utils/config";
// import {
//     FaUserCheck, FaFileAlt, FaCheckCircle,
//     FaChevronLeft, FaPaperPlane, FaShieldAlt,
//     FaRocket, FaInfoCircle, FaEnvelope, FaImage,
//     FaUpload, FaCloudUploadAlt, FaDownload, FaStamp
// } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { jsPDF } from "jspdf";

// const InfoItem = ({ label, value }) => (
//     <div className="flex flex-col">
//         <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest leading-relaxed">{label}</p>
//         <p className="text-sm font-bold text-gray-800 tracking-tight">{value || "N/A"}</p>
//     </div>
// );

// const renderMarkdown = (text) => {
//     if (!text) return "";
//     let html = text
//         .replace(/^# (.*$)/gm, '<h1 class="text-2xl font-black mb-6 text-gray-900 border-b-2 border-gray-100 pb-4">$1</h1>')
//         .replace(/^## (.*$)/gm, '<h2 class="text-xl font-bold mb-4 text-gray-800 mt-8">$1</h2>')
//         .replace(/^### (.*$)/gm, '<h3 class="text-sm font-black mb-4 text-blue-600 uppercase tracking-[0.2em] mt-8">$1</h3>')
//         .replace(/\*\*(.*?)\*\*/gm, '<strong>$1</strong>')
//         .replace(/\*(.*?)\*/gm, '<em>$1</em>')
//         .replace(/^- (.*$)/gm, '<li class="ml-2 mb-2 text-gray-700">$1</li>');

//     // Simple paragraph handling
//     return html.split('\n').map(line => line.trim() ? `<p class="mb-2">${line}</p>` : '<div class="h-4"></div>').join('');
// };

// const SendOffer = () => {
//     const query = new URLSearchParams(useLocation().search);
//     const applicationId = query.get("id");
//     const candidateEmail = query.get("email");
//     const navigate = useNavigate();

//     const [loading, setLoading] = useState(false);
//     const [fetching, setFetching] = useState(true);
//     const [candidate, setCandidate] = useState(null);
//     const [documentType, setDocumentType] = useState("Offer");
//     const [offerContent, setOfferContent] = useState("");
//     const [attachment, setAttachment] = useState(null);
//     const [isPreview, setIsPreview] = useState(false);
//     const [logoUrl, setLogoUrl] = useState("https://placehold.co/200x60/6366f1/ffffff?text=Timely+Health");
//     const [stampUrl, setStampUrl] = useState("");
//     const [signatureUrl, setSignatureUrl] = useState(null);

//     const [docsVerified, setDocsVerified] = useState({
//         resume: true,
//         idProof: false,
//         academicCertificates: false,
//         experienceLetter: false,
//     });

//     useEffect(() => {
//         fetchSettings();
//         if (applicationId || candidateEmail) {
//             fetchApplicationDetails();
//         } else {
//             setFetching(false);
//         }
//     }, [applicationId, candidateEmail]);

//     const fetchSettings = async () => {
//         try {
//             const res = await axios.get(`${API_BASE_URL}/admin/settings`);
//             if (res.data.success && res.data.settings.companyLogo) {
//                 const logo = res.data.settings.companyLogo;
//                 setLogoUrl(logo.startsWith('http') ? logo : `${API_DOMAIN}${logo}`);
//             }
//             if (res.data.success && res.data.settings.companyStamp) {
//                 const stamp = res.data.settings.companyStamp;
//                 setStampUrl(stamp.startsWith('http') ? stamp : `${API_DOMAIN}${stamp}`);
//             }
//         } catch (err) {
//             console.error("Failed to fetch settings:", err);
//         }
//     };

//     const handleLogoUpload = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         const formData = new FormData();
//         formData.append("logo", file);

//         try {
//             setLoading(true);
//             const res = await axios.post(`${API_BASE_URL}/admin/logo`, formData, {
//                 headers: { "Content-Type": "multipart/form-data" }
//             });
//             if (res.data.success) {
//                 const logo = res.data.logoUrl;
//                 setLogoUrl(logo.startsWith('http') ? logo : `${API_DOMAIN}${logo}`);
//                 toast.success("Logo updated successfully");
//             }
//         } catch (err) {
//             toast.error("Logo upload failed");
//             console.error(err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleStampUpload = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         const formData = new FormData();
//         formData.append("stamp", file);

//         try {
//             setLoading(true);
//             const res = await axios.post(`${API_BASE_URL}/admin/stamp`, formData, {
//                 headers: { "Content-Type": "multipart/form-data" }
//             });
//             if (res.data.success) {
//                 const stamp = res.data.stampUrl;
//                 setStampUrl(stamp.startsWith('http') ? stamp : `${API_DOMAIN}${stamp}`);
//                 toast.success("Stamp updated successfully");
//             }
//         } catch (err) {
//             toast.error("Stamp upload failed");
//             console.error(err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Handle signature upload (client-side preview, no server storage)
//     const handleSignatureUpload = (e) => {
//         const file = e.target.files[0];
//         if (!file) return;
//         const reader = new FileReader();
//         reader.onload = () => {
//             setSignatureUrl(reader.result);
//         };
//         reader.readAsDataURL(file);
//     };

//     const getTemplate = (type, data) => {
//         const { name, email, role, date, joiningDate, salary, location, noticePeriod, probationPeriod, dailyAllowance, performanceAllowance } = data;

//         switch (type) {
//             case "Appraisal":
//                 return `
//  EMPLOYMENT APPRAISAL LETTER

// Date: ${date}

// To:
// ${name}
// Email: ${email}

// Subject: Annual Performance Appraisal & Salary Revision

// Dear ${name},

// Following our recent performance review for the previous financial year, we are pleased to inform you that your contribution to Timely Health has been exemplary. We value your commitment and are delighted to reward your hard work.

// REVISION DETAILS:
// New Designation: ${role}
// Revised CTC: ${salary}
// Effective Date: [Specify Date]

// We look forward to your continued growth and success with the organization. Keep up the excellent work!

// Best Regards,

// Management
// Timely Health Group
//                 `.trim();

//             case "Warning":
//                 return `
// DISCIPLINARY WARNING LETTER

// Date: ${date}

// To:
// ${name}
// Email: ${email}

// Subject: Formal Warning Regarding [Performance/Conduct]

// Dear ${name},

// This letter serves as a formal warning regarding your recent [Performance/Conduct] issues observed between [Start Date] and [End Date]. Specifically, we have noted concerns regarding:

// - [Issue 1: e.g., Recurring tardiness]
// - [Issue 2: e.g., Delayed deliverables]

// REQUIRED ACTIONS:
// Please ensure immediate improvement in the areas mentioned above. Failure to do so may result in further disciplinary action, up to and including termination of employment.

// We hope to see a positive change in your performance moving forward.

// Best Regards,

// Human Resources Department
// Timely Health Group
//                 `.trim();

//             case "Termination":
//                 return `
// EMPLOYMENT TERMINATION NOTICE

// Date: ${date}

// To:
// ${name}
// Email: ${email}

// Subject: Notice of Termination of Employment

// Dear ${name},

// We regret to inform you that your employment with Timely Health is being terminated, effective [Effective Date], due to [Reason: e.g., Structural Redundancy / Performance Concerns].

// FINAL SETTLEMENT:
// Last Working Day:[Date]
// Notice Period: [Details]
// Outstanding Dues: To be settled within 45 days of the last working day.

// Please return all company property (Laptop, ID Card, etc.) by your last working day to the HR department.

// We wish you the best in your future endeavors.

// Best Regards,

// Head of Human Resources
// Timely Health Group
//                 `.trim();

//             case "Agreement":
//                 return `
// EMPLOYMENT AGREEMENT - TERMS & CONDITIONS

// Date: ${date}

// BETWEEN:
// Timely Health PVT LTD (The Company)
// AND:
// ${name} (The Candidate)

// 1. CONFIDENTIALITY
// The employee agrees to keep all company information, trade secrets, and client data strictly confidential during and after employment. This includes but is not limited to financial data, client lists, and internal processes.

// 2. INTELLECTUAL PROPERTY
// Any work produced, developed, or conceived by the employee during the course of employment shall be the sole and exclusive property of the Company.

// 3. CODE OF CONDUCT
// The employee shall adhere to the company's code of conduct, professional ethics, and internal policies as outlined in the Employee Handbook.

//  4. NON-COMPETE & NON-SOLICITATION
// The employee agrees not to engage in any business that competes with the Company or solicit its clients/employees for a period of 12 months after termination.

// 5. TERMINATION NOTICE
// Both parties agree to a notice period as specified in the Offer Letter for termination of this agreement.

// Acceptance:**
// By signing and uploading this document, the candidate formally accepts the terms and conditions of employment with Timely Health.

// Best Regards,

// Legal Department
// Timely Health Group
//                 `.trim();

//             default:
//                 return `
// EMPLOYMENT OFFER LETTER

// Date: ${date}

// To:
// ${name}
// Email: ${email}

// Subject: Offer of Employment - ${role}

// Dear ${name},

// In reference to your last interview and subsequent discussion, we have the pleasure of offering you the appointment for the post of ${role} in our organization Timely Healthtech Private Limited. 
// On ${joiningDate} you are to report to the HR Manager. 
// You will be on probation for a period of ${probationPeriod || "One Year"} from joining Date.
// Your salary will be ${salary} (Consolidated Pay).

// Read this offer letter carefully, sign with the date & return the duplicate copy of this letter to us as a token of your acceptance of the appointment.

// Congratulations!

// Welcome to the team Timely Health, 

// Best Wishes.

// Yours Sincerely,
// HR Manager
// Timely Health.

// Please Report at the address given above by 10 AM and please bring a copy of the following Testimonials/certificates at the time of reporting:
// a) ID Proof (Aadhar/Ration card/Driving license/Passport/Election ID)
// b) Xerox copies of all Educational Documents
// c) Original certificates of your past experience, including certificate from your last employer
// d) Please also bring 4 passport size photographs, which we required for our records 

// Annexure A

// 1. Posting and Transfer
// Your services are liable to be transferred, at the sole discretion of Management, in such other capacity as the company may determine, to any department / section, location, associate, sister concern or subsidiary, at any place in India or abroad, whether existing today or which may come up in future. In such a case, you will be governed by the terms and conditions of the service applicable at the new placement location.

// 2. Probation
// That you will be on probation for a period of ${probationPeriod || "twelve months"}. The period of probation can be extended at the discretion of the Management and you will continue to be on probation till an order of confirmation has been issued in writing.

// 3. Full time employment
// Your position is a whole time employment with the Company and you shall devote yourself exclusively to the business and interests of the company. You will not take up any other work for remuneration (part time or otherwise) or work in an advisory capacity, or be interested directly or indirectly (except as shareholder / debenture holder), in any other trade or business during your employment with the company, without permission in writing of the Management of the Company. You will also not seek membership of any local or public bodies without first obtaining specific permission from the Management.

// 4. Confidentiality
// You will not share any information at any time, during the employment or after, without the consent of the Management disclose or divulge or make public, except on legal obligations, any information regarding the Company’s affairs or administration or research carried out, whether the same is confided to you or becomes known to you in the course of your service or otherwise.

// 5. Intellectual Property
// If you conceive any new or advanced method of improving designs/ processes/ formulae/ systems, etc. in relation to the business/ operations of the Company, such developments will be fully communicated to the company and will remain the sole right/ property of the Company.

// 6. Responsibilities & Duties
// Your work in the organization will be subject to the rules and regulations of the organization as laid down in relation to conduct, discipline and other matters. You will always be alive to responsibilities and duties attached to your office and conduct yourself accordingly. You must effectively perform to ensure results.

// 7. Past Records
// This letter of appointment is based on the information furnished in your application for employment and during the interviews you had with us. If any declaration given, or information furnished by you, to the company proves to be false, or if you are found to have willfully suppressed any material information, in such cases, you will be liable to removal from services without any notice.

// 8. Termination of employment
// During the probationary period and any extension thereof, your services may be terminated without giving any notice or salary in lieu thereof. However, on confirmation the services can be terminated from either side by giving one month (30 days) notice or salary in lieu thereof. Upon resignation/termination of employment, you will immediately hand over to the Company all correspondence, specifications, formulae, books, documents, market data, cost data, drawings, affects or records belonging to the Company or relating to its business and shall not retain or make copies of these items.
// Upon resignation/termination of employment, you will also return all company property, which may be in your possession. Notwithstanding the above condition, the contract of service may also be terminated because of under mentioned stipulations. This will be without payment of any compensation. If you fail, refuse or neglect to carry out and perform your duties assigned to you by the company. For loss of confidence in you by the company for any of the acts committed by you.
// If you are found to be guilty of fraud, insubordination or misconduct whether in course of performance of duties entrusted to you or otherwise. If you are found unfit for being entrusted with the responsible work commensurate with your position in consequences of any misconduct, moral turpitude. * If you commit any act prejudicial to the continuing good relationship between you and the company.
// If you commit breach of any of the terms of this letter of appointment.

// 9. Authority
// No authority is vested upon you to make any financial commitment and enter into agreements/contracts/understandings of any nature with any second party and third party without seeking the prior permission/approval of the management. Any violation to exceed your specified authority as mentioned will be seriously viewed and disciplinary/appropriate legal action will be taken.

// Benefits and Allowances: 
// Daily Allowance: ${dailyAllowance || "NA"}
// Performance allowances: ${performanceAllowance || "NA"}
// Health Benefits: Free Doctor Consultations at our associate clinics/ Hospitals 
// Diagnostic/ Tests/ Health Check-ups: 
// a. Employee self:-up to 70% off on MRP. 
// b. Immediate Family members:- up to 40% of MRP.
// c. Other Family members/ Relatives:- up to 30% of on MRP
// Salary appraisal cycle: April/ 1st Month of Every financial year. Candidate minimum working days for participating in appraisal scheme is 120 days from the date of Joining.
//                 `.trim();
//         }
//     };

//     const fetchApplicationDetails = async () => {
//         try {
//             setFetching(true);
//             let app = null;

//             if (applicationId && applicationId !== "undefined") {
//                 const res = await axios.get(`${API_BASE_URL}/applications/get/${applicationId}`);
//                 if (res.data.success) app = res.data.application;
//             }

//             if (!app && candidateEmail) {
//                 const res = await axios.get(`${API_BASE_URL}/applications/all`);
//                 if (res.data.success) {
//                     app = res.data.applications.find(a => a.email === candidateEmail);
//                 }
//             }

//             if (app) {
//                 setCandidate(app);
//                 if (app.documentsVerified) {
//                     setDocsVerified({
//                         resume: app.documentsVerified.resume || false,
//                         idProof: app.documentsVerified.idProof || false,
//                         academicCertificates: app.documentsVerified.academicCertificates || app.documentsVerified.educationalDocs || false,
//                         experienceLetter: app.documentsVerified.experienceLetter || false,
//                     });
//                 }

//                 const data = {
//                     name: `${app.firstName} ${app.lastName}`,
//                     email: app.email || "[Candidate Email]",
//                     role: app.jobId?.role || "Team Member",
//                     date: new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' }),
//                     joiningDate: app.dateOfJoining ? new Date(app.dateOfJoining).toLocaleDateString() : "[To be discussed]",
//                     salary: app.finalSalary ? `INR ${app.finalSalary} per annum` : (app.expectedCTC ? `INR ${app.expectedCTC} per annum` : "As per agreed terms"),
//                     location: app.currentLocation || "Corporate Office",
//                     noticePeriod: app.noticePeriod || "",
//                     probationPeriod: app.probationPeriod || "",
//                     dailyAllowance: app.dailyAllowance || "",
//                     performanceAllowance: app.performanceAllowance || "",
//                 };

//                 const type = documentType || "Offer";
//                 setOfferContent(getTemplate(type, data));
//             }
//         } catch (err) {
//             console.error(err);
//             toast.error("Failed to fetch candidate details");
//         } finally {
//             setFetching(false);
//         }
//     };

//     const handleVerifyChange = (key) => setDocsVerified(s => ({ ...s, [key]: !s[key] }));

//     const getBase64ImageFromUrl = (imgUrl) => {
//         return new Promise((resolve) => {
//             const img = new Image();
//             img.crossOrigin = "Anonymous";
//             img.onload = () => {
//                 const canvas = document.createElement("canvas");
//                 canvas.width = img.width;
//                 canvas.height = img.height;
//                 const ctx = canvas.getContext("2d");
//                 ctx.drawImage(img, 0, 0);
//                 resolve({ dataUrl: canvas.toDataURL("image/png"), width: img.width, height: img.height });
//             };
//             img.onerror = () => resolve(null);
//             img.src = imgUrl;
//         });
//     };

//     const handleDownload = async () => {
//         if (!offerContent) return toast.error("No content to download");
        
//         try {
//             setLoading(true);
//             const doc = new jsPDF();
//             const pageWidth = doc.internal.pageSize.getWidth();
//             const margin = 20;
//             const contentWidth = pageWidth - (2 * margin);

//             // --- Header & Logo ---
//             const logoBase64 = await getBase64ImageFromUrl(logoUrl);
//             if (logoBase64 && logoBase64.dataUrl) {
//                 const ratio = logoBase64.width / logoBase64.height;
//                 const imgHeight = 12;
//                 const imgWidth = imgHeight * ratio;
//                 doc.addImage(logoBase64.dataUrl, "PNG", margin, 15, imgWidth, imgHeight);
//             } else {
//                 doc.setFont("helvetica", "bold");
//                 doc.setFontSize(20);
//                 doc.text("TIMELY HEALTH", margin, 25);
//             }

//             doc.setFontSize(14);
//             doc.setFont("helvetica", "bold");
//             doc.setTextColor(63, 81, 181);
//             doc.text(`${documentType.toUpperCase()} LETTER`, pageWidth - margin, 25, { align: "right" });

//             doc.setDrawColor(226, 232, 240);
//             doc.line(margin, 35, pageWidth - margin, 35);

//             let currentY = 50;
//             doc.setFontSize(10);
//             doc.setTextColor(30, 41, 59);
            
//             // Clean up content: remove extra spaces from the start of lines in template strings
//             const cleanContent = offerContent.split('\n').map(line => line.trim()).join('\n');
//             const paragraphs = cleanContent.split('\n\n');
            
//             paragraphs.forEach(para => {
//                 if (para.trim() === '---') {
//                     doc.setDrawColor(226, 232, 240);
//                     doc.line(margin, currentY, pageWidth - margin, currentY);
//                     currentY += 10;
//                     return;
//                 }

//                 // Handle section headers (starting with ###)
//                 if (para.startsWith('###')) {
//                     doc.setFont("helvetica", "bold");
//                     doc.setFontSize(11);
//                     doc.setTextColor(37, 99, 235);
//                     const headingText = para.replace('###', '').trim();
//                     doc.text(headingText.toUpperCase(), margin, currentY);
//                     currentY += 8;
//                     doc.setFontSize(10);
//                     doc.setTextColor(30, 41, 59);
//                     doc.setFont("helvetica", "normal");
//                     return;
//                 }

//                 // Handle bold text (simple implementation for **text**)
//                 doc.setFont("helvetica", "normal");
//                 const lines = doc.splitTextToSize(para, contentWidth);
                
//                 lines.forEach(line => {
//                     if (currentY > 275) {
//                         doc.addPage();
//                         currentY = 20;
//                     }
                    
//                     // Basic bold detection for the whole line if needed, or just normal
//                     if (line.includes('**')) {
//                         doc.setFont("helvetica", "bold");
//                         doc.text(line.replace(/\*\*/g, ''), margin, currentY);
//                         doc.setFont("helvetica", "normal");
//                     } else {
//                         doc.text(line, margin, currentY);
//                     }
//                     currentY += 6;
//                 });
//             });

//             // --- Footer Signatures with Stamp ---
//             currentY += 20;
//             if (currentY > 260) {
//                 doc.addPage();
//                 currentY = 30;
//             }

//             doc.setDrawColor(226, 232, 240);
//             doc.line(margin, currentY, pageWidth - margin, currentY);
//             currentY += 15;

//             // Candidate Signature (LEFT)
//             doc.setFont("helvetica", "bold");
//             doc.setFontSize(9);
//             doc.setTextColor(30, 41, 59);
//             doc.text("CANDIDATE SIGNATURE", margin, currentY);
//             doc.setDrawColor(200, 200, 200);
//             doc.line(margin, currentY + 12, margin + 60, currentY + 12);

//             // Add Stamp if available (RIGHT side before signature)
//             if (stampUrl) {
//                 const stampBase64 = await getBase64ImageFromUrl(stampUrl);
//                 if (stampBase64 && stampBase64.dataUrl) {
//                     const stampRatio = stampBase64.width / stampBase64.height;
//                     const stampHeight = 25;
//                     const stampWidth = stampHeight * stampRatio;
//                     doc.addImage(stampBase64.dataUrl, "PNG", pageWidth - margin - stampWidth - 10, currentY - 8, stampWidth, stampHeight);
//                 }
//             }

//             // Authorized Signatory (RIGHT)
//             doc.setFont("helvetica", "bold");
//             doc.text("AUTHORIZED SIGNATORY", pageWidth - margin, currentY, { align: "right" });
//             doc.setFont("helvetica", "normal");
//             doc.text("Director - Human Resources", pageWidth - margin, currentY + 12, { align: "right" });
//             doc.setDrawColor(200, 200, 200);
//             doc.line(pageWidth - margin - 60, currentY + 10, pageWidth - margin, currentY + 10);
//             // Draw uploaded signature image if available
//             if (signatureUrl) {
//                 const sigBase64 = await getBase64ImageFromUrl(signatureUrl);
//                 if (sigBase64 && sigBase64.dataUrl) {
//                     const sigRatio = sigBase64.width / sigBase64.height;
//                     const sigHeight = 12; // match line height
//                     const sigWidth = sigHeight * sigRatio;
//                     const sigX = pageWidth - margin - sigWidth;
//                     const sigY = currentY + 14; // position below the name
//                     doc.addImage(sigBase64.dataUrl, "PNG", sigX, sigY, sigWidth, sigHeight);
//                 }
//             }

//             doc.save(`${documentType}_Letter_${candidate?.firstName || "Candidate"}.pdf`);
//             toast.success("Document downloaded successfully");
//         } catch (err) {
//             console.error("Download failed:", err);
//             toast.error("Failed to generate PDF");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSendOffer = async () => {
//         const appId = applicationId || candidate?._id;
//         if (!appId) return toast.error("No Application ID found");

//         try {
//             setLoading(true);

//             if (documentType === "Agreement" || attachment) {
//                 const formData = new FormData();
//                 formData.append("applicationId", appId);
//                 formData.append("email", candidateEmail || candidate?.email);
//                 formData.append("agreementsContent", offerContent); // Shared field for agreements
//                 formData.append("documentType", documentType);
//                 if (attachment) {
//                     formData.append("adminAttachment", attachment);
//                 }

//                 const endpoint = documentType === "Agreement" ? "send-agreements" : "send-offer";
//                 const res = await axios.post(`${API_BASE_URL}/applications/${endpoint}`, formData, {
//                     headers: { "Content-Type": "multipart/form-data" }
//                 });

//                 if (res.data.success) {
//                     toast.success(`${documentType} dispatched successfully`);
//                     navigate("/score");
//                 }
//             } else {
//                 const res = await axios.post(`${API_BASE_URL}/applications/send-offer`, {
//                     applicationId: appId,
//                     email: candidateEmail || candidate?.email,
//                     offerLetterContent: offerContent,
//                     documentsVerified: docsVerified,
//                     documentType: documentType
//                 });

//                 if (res.data.success) {
//                     toast.success("Offer letter dispatched successfully");
//                     navigate("/score");
//                 }
//             }
//         } catch (err) {
//             toast.error("Dispatch Failed: " + (err.response?.data?.message || err.message));
//         } finally {
//             setLoading(false);
//         }
//     };

//     if (fetching) return (
//         <div className="min-h-screen flex items-center justify-center bg-white">
//             <div className="flex flex-col items-center gap-6">
//                 <div className="w-12 h-12 border-4 border-purple-600 border-t-transparent rounded-full animate-spin"></div>
//                 <div className="text-center">
//                     <p className="text-base font-bold text-gray-800">Drafting Offer...</p>
//                 </div>
//             </div>
//         </div>
//     );

//     return (
//         <div className="p-3 mx-auto bg-white rounded-lg shadow-md max-w-full min-h-screen">
//             <div className="flex flex-col gap-6">
//                 {/* Header Section */}
//                 <div className="flex flex-col gap-4 mb-2 xl:flex-row xl:items-center xl:justify-between px-2">
//                     <div className="flex items-center gap-4">
//                         <button
//                             onClick={() => navigate(-1)}
//                             className="flex items-center gap-2 px-3 py-2 text-sm font-bold text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors shadow-sm"
//                         >
//                             <FaChevronLeft className="text-xs" /> Back
//                         </button>
//                         <div>
//                             <h1 className="text-xl font-bold text-gray-800 flex items-center gap-2">
//                                 Dispatch Offer Letter
//                             </h1>
//                             <p className="text-gray-400 text-[10px] font-black mt-1 uppercase tracking-widest">
//                                 Professional Documentation Pipeline
//                             </p>
//                         </div>
//                     </div>

//                     {candidate && (
//                         <div className="flex items-center gap-4 bg-gray-50 px-5 py-3 rounded-2xl border border-gray-100 shadow-sm">
//                             <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-blue-600 rounded-xl flex items-center justify-center text-white text-lg font-black shadow-lg shadow-blue-100">
//                                 {candidate.firstName.charAt(0)}
//                             </div>
//                             <div className="flex flex-col">
//                                 <span className="text-sm font-bold text-gray-800 leading-tight">{candidate.firstName} {candidate.lastName}</span>
//                                 <span className="text-[10px] font-black text-blue-600 uppercase tracking-widest">{candidate.jobId?.role}</span>
//                             </div>
//                         </div>
//                     )}
//                 </div>

//                 <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 p-2">
//                     {/* Left: Configuration Sidebar */}
//                     <div className="lg:col-span-4 space-y-6">
//                         {/* Document Type */}
//                         <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm">
//                             <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-5 flex items-center gap-2">
//                                 <FaFileAlt className="text-purple-500" /> Document Type
//                             </h3>
//                             <div className="space-y-2">
//                                 {["Offer", "Appraisal", "Warning", "Termination", "Agreement"].map((type) => (
//                                     <button
//                                         key={type}
//                                         onClick={() => {
//                                             if (window.confirm(`Switch to ${type} template? This will overwrite your current edits.`)) {
//                                                 setDocumentType(type);
//                                                 const data = {
//                                                     name: `${candidate?.firstName} ${candidate?.lastName}`,
//                                                     email: candidate?.email || "[Candidate Email]",
//                                                     role: candidate?.jobId?.role || "Team Member",
//                                                     date: new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' }),
//                                                     joiningDate: candidate?.dateOfJoining ? new Date(candidate?.dateOfJoining).toLocaleDateString() : "[To be discussed]",
//                                                     salary: candidate?.finalSalary ? `INR ${candidate?.finalSalary} per annum` : (candidate?.expectedCTC ? `INR ${candidate?.expectedCTC} per annum` : "As per agreed terms"),
//                                                     location: candidate?.currentLocation || "Corporate Office",
//                                                     noticePeriod: candidate?.noticePeriod || "",
//                                                     probationPeriod: candidate?.probationPeriod || "",
//                                                     dailyAllowance: candidate?.dailyAllowance || "",
//                                                     performanceAllowance: candidate?.performanceAllowance || "",
//                                                 };
//                                                 setOfferContent(getTemplate(type, data));
//                                             }
//                                         }}
//                                         className={`w-full text-left p-3 rounded-xl border transition-all text-[10px] font-black uppercase tracking-widest ${documentType === type ? 'bg-purple-50 border-purple-200 text-purple-700' : 'bg-gray-50 border-gray-100 text-gray-400 hover:bg-white hover:text-gray-600'}`}
//                                     >
//                                         {type} {type === "Agreement" ? "Docs" : "Letter"}
//                                     </button>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* File Attachment - Only for Agreement or optionally others */}
//                         <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm">
//                             <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-5 flex items-center gap-2">
//                                 <FaUpload className="text-emerald-500" /> Attachment (Optional)
//                             </h3>
//                             <div className="space-y-4">
//                                 <div className="relative border-2 border-dashed border-gray-100 rounded-xl p-4 flex flex-col items-center justify-center hover:bg-gray-50 transition-colors pointer-cursor">
//                                     <input
//                                         type="file"
//                                         onChange={(e) => setAttachment(e.target.files[0])}
//                                         className="absolute inset-0 opacity-0 cursor-pointer"
//                                     />
//                                     <FaCloudUploadAlt className={`text-2xl mb-2 ${attachment ? "text-emerald-500" : "text-gray-300"}`} />
//                                     <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest text-center">
//                                         {attachment ? attachment.name : "Upload PDF Attachment"}
//                                     </p>
//                                 </div>
//                                 {attachment && (
//                                     <button
//                                         onClick={() => setAttachment(null)}
//                                         className="w-full py-2 text-[8px] font-black text-rose-500 uppercase tracking-widest hover:bg-rose-50 rounded-lg transition-colors"
//                                     >
//                                         Remove Attachment
//                                     </button>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Company Branding - Logo and Stamp */}
//                         <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm">
//                             <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-5 flex items-center gap-2">
//                                 <FaImage className="text-blue-500" /> Company Branding
//                             </h3>
//                             <div className="space-y-6">
//                                 {/* Logo Upload */}
//                                 <div>
//                                     <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-3">Company Logo</p>
//                                     <div className="relative border-2 border-dashed border-gray-100 rounded-xl p-4 flex flex-col items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer group">
//                                         <input
//                                             type="file"
//                                             accept="image/*"
//                                             onChange={handleLogoUpload}
//                                             className="absolute inset-0 opacity-0 cursor-pointer"
//                                         />
//                                         <FaUpload className="text-xl mb-2 text-gray-300 group-hover:text-blue-500 transition-colors" />
//                                         <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest text-center">
//                                             Update Company Logo
//                                         </p>
//                                     </div>
//                                     <div className="h-20 bg-gray-50 rounded-xl border border-gray-100 flex items-center justify-center p-3 mt-3">
//                                         <img 
//                                             src={logoUrl} 
//                                             alt="Logo Preview" 
//                                             className="max-h-full max-w-full object-contain" 
//                                             onError={(e) => e.target.src = 'https://placehold.co/200x60/6366f1/ffffff?text=Timely+Health'} 
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Stamp Upload */}
//                                 <div>
//                                     <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-3 flex items-center gap-2">
//                                         <FaStamp className="text-amber-500" /> Company Stamp
//                                     </p>
//                                     <div className="relative border-2 border-dashed border-gray-100 rounded-xl p-4 flex flex-col items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer group">
//                                         <input
//                                             type="file"
//                                             accept="image/*"
//                                             onChange={handleStampUpload}
//                                             className="absolute inset-0 opacity-0 cursor-pointer"
//                                         />
//                                         <FaUpload className="text-xl mb-2 text-gray-300 group-hover:text-amber-500 transition-colors" />
//                                         <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest text-center">
//                                             Update Company Stamp
//                                         </p>
//                                     </div>
//                                     {stampUrl && (
//                                         <div className="h-20 bg-gray-50 rounded-xl border border-gray-100 flex items-center justify-center p-3 mt-3">
//                                             <img 
//                                                 src={stampUrl} 
//                                                 alt="Stamp Preview" 
//                                                 className="max-h-full max-w-full object-contain" 
//                                             />
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* Signature Upload */}
//                                 <div>
//                                     <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-3 flex items-center gap-2">
//                                         <FaStamp className="text-green-500" /> Authorized Signature
//                                     </p>
//                                     <div className="relative border-2 border-dashed border-gray-100 rounded-xl p-4 flex flex-col items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer group">
//                                         <input
//                                             type="file"
//                                             accept="image/*"
//                                             onChange={handleSignatureUpload}
//                                             className="absolute inset-0 opacity-0 cursor-pointer"
//                                         />
//                                         <FaUpload className="text-xl mb-2 text-gray-300 group-hover:text-green-500 transition-colors" />
//                                         <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest text-center">
//                                             Upload Authorized Signature
//                                         </p>
//                                     </div>
//                                     {signatureUrl && (
//                                         <div className="h-28 bg-gray-50 rounded-xl border border-gray-100 flex items-center justify-center p-4 mt-3">
//                                             <img 
//                                                 src={signatureUrl} 
//                                                 alt="Signature Preview" 
//                                                 className="max-h-full max-w-full object-contain" 
//                                             />
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Right: Main Content Area */}
//                     <div className="lg:col-span-8">
//                         <div className="bg-white rounded-2xl border border-gray-100 shadow-lg overflow-hidden flex flex-col min-h-[750px]">
//                             {/* Tabs synchronized with JobApplicants detail style */}
//                             <div className="flex bg-gray-50/50 p-1.5 gap-1.5 border-b border-gray-100">
//                                 <button
//                                     onClick={() => setIsPreview(false)}
//                                     className={`flex-1 py-3 px-4 rounded-xl text-[10px] font-black uppercase tracking-[0.2em] transition-all ${!isPreview ? 'bg-white text-purple-600 shadow-sm border border-gray-100' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'}`}
//                                 >
//                                     Template Editor
//                                 </button>
//                                 <button
//                                     onClick={() => setIsPreview(true)}
//                                     className={`flex-1 py-3 px-4 rounded-xl text-[10px] font-black uppercase tracking-[0.2em] transition-all ${isPreview ? 'bg-white text-blue-600 shadow-sm border border-gray-100' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'}`}
//                                 >
//                                     Preview
//                                 </button>
//                                 <button
//                                     onClick={handleDownload}
//                                     disabled={loading}
//                                     className="flex-1 py-3 px-4 rounded-xl text-[10px] font-black uppercase tracking-[0.2em] transition-all text-gray-400 hover:text-emerald-600 hover:bg-emerald-50 flex items-center justify-center gap-2 disabled:opacity-50"
//                                 >
//                                     <FaDownload /> Download
//                                 </button>
//                             </div>

//                             <div className="flex-1 p-8 flex flex-col">
//                                 {isPreview ? (
//                                     <div className="flex-1 bg-white border border-gray-100 rounded-xl p-12 overflow-y-auto max-h-[600px] shadow-inner relative animate-in fade-in duration-500">
//                                         <div className="flex justify-between items-start mb-16 px-4">
//                                             <img src={logoUrl} alt="Logo" className="h-10 object-contain" />
//                                             <div className="text-right">
//                                                 <p className="text-base font-black text-gray-900 tracking-tight uppercase leading-none">
//                                                     {documentType} {documentType === "Agreement" ? "Document" : "Letter"}
//                                                 </p>
//                                                 <p className="text-[9px] font-bold text-gray-400 mt-2 uppercase tracking-[0.2em]">Authentic Documentation</p>
//                                             </div>
//                                         </div>

//                                         <div
//                                             className="markdown-content text-sm leading-relaxed text-gray-700 font-serif px-4"
//                                             dangerouslySetInnerHTML={{ __html: renderMarkdown(offerContent) }}
//                                         />

//                                         <div className="mt-20 flex justify-between items-end border-t border-gray-100 pt-10 px-4">
//                                             <div className="flex flex-col gap-10">
//                                                 <p className="text-[9px] font-black text-gray-800 uppercase tracking-widest">Candidate Signature</p>
//                                                 <div className="w-48 h-[1px] bg-gray-200"></div>
//                                             </div>
//                                             <div className="flex flex-col gap-10 items-end">
//                                                 {stampUrl && (
//                                                     <img src={stampUrl} alt="Stamp" className="h-16 object-contain mb-2" />
//                                                 )}
//                                                 <p className="text-[9px] font-black text-gray-800 uppercase tracking-widest text-right">Authorized Signatory</p>
//                                                 <div className="w-48 h-[1px] bg-gray-200"></div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                 ) : (
//                                     <textarea
//                                         className="flex-1 w-full p-8 border border-gray-100 rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-500/5 focus:border-blue-300 transition-all font-mono text-[11px] leading-relaxed resize-none bg-gray-50/50 text-gray-600 shadow-inner"
//                                         value={offerContent}
//                                         onChange={(e) => setOfferContent(e.target.value)}
//                                         placeholder="Draft the official offer content here..."
//                                     />
//                                 )}

//                                 <div className="mt-8 flex flex-col md:flex-row justify-between items-center gap-6 pt-8 border-t border-gray-50">
//                                     <div className="flex items-center gap-4">
//                                         <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-purple-500 to-blue-600 flex items-center justify-center shadow-lg shadow-purple-100">
//                                             <FaRocket size={16} className="text-white animate-pulse" />
//                                         </div>
//                                         <div>
//                                             <p className="text-[10px] font-black text-gray-800 uppercase tracking-widest">Validated Template</p>
//                                             <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">Ready for secure dispatch</p>
//                                         </div>
//                                     </div>

//                                     <button
//                                         className={`w-full md:w-auto px-10 py-4 bg-blue-600 text-white rounded-xl font-bold text-xs uppercase tracking-widest hover:bg-blue-700 transition-all flex items-center justify-center gap-3 shadow-lg shadow-blue-100 disabled:opacity-50 disabled:pointer-events-none`}
//                                         disabled={loading}
//                                         onClick={handleSendOffer}
//                                     >
//                                         {loading ? "Transmitting..." : <><FaPaperPlane /> Dispatch {documentType}</>}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SendOffer;





import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE_URL, API_DOMAIN } from "../utils/config";
import {
    FaUserCheck, FaFileAlt, FaCheckCircle,
    FaChevronLeft, FaPaperPlane, FaShieldAlt,
    FaRocket, FaInfoCircle, FaEnvelope, FaImage,
    FaUpload, FaCloudUploadAlt, FaDownload, FaStamp,
    FaArrowLeft, FaArrowRight, FaPrint
} from "react-icons/fa";
import { toast } from "react-toastify";
import { jsPDF } from "jspdf";

const SendOffer = () => {
    const query = new URLSearchParams(useLocation().search);
    const applicationId = query.get("id");
    const candidateEmail = query.get("email");
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [candidate, setCandidate] = useState(null);
    const [documentType, setDocumentType] = useState("Offer");
    const [offerContent, setOfferContent] = useState("");
    const [attachment, setAttachment] = useState(null);
    const [isPreview, setIsPreview] = useState(false);
    const [logoUrl, setLogoUrl] = useState("https://placehold.co/200x60/6366f1/ffffff?text=Timely+Health");
    const [stampUrl, setStampUrl] = useState("");
    const [signatureUrl, setSignatureUrl] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [previewPdfUrl, setPreviewPdfUrl] = useState(null);
    const [isGeneratingPreview, setIsGeneratingPreview] = useState(false);
    const iframeRef = useRef(null);

    const [docsVerified, setDocsVerified] = useState({
        resume: true,
        idProof: false,
        academicCertificates: false,
        experienceLetter: false,
    });

    useEffect(() => {
        fetchSettings();
        if (applicationId || candidateEmail) {
            fetchApplicationDetails();
        } else {
            setFetching(false);
        }
    }, [applicationId, candidateEmail]);

    useEffect(() => {
        if (isPreview && offerContent) {
            generatePreviewPDF();
        }
    }, [isPreview, offerContent, logoUrl, stampUrl, signatureUrl, documentType]);

    const fetchSettings = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/admin/settings`);
            if (res.data.success && res.data.settings.companyLogo) {
                const logo = res.data.settings.companyLogo;
                setLogoUrl(logo.startsWith('http') ? logo : `${API_DOMAIN}${logo}`);
            }
            if (res.data.success && res.data.settings.companyStamp) {
                const stamp = res.data.settings.companyStamp;
                setStampUrl(stamp.startsWith('http') ? stamp : `${API_DOMAIN}${stamp}`);
            }
        } catch (err) {
            console.error("Failed to fetch settings:", err);
        }
    };

    const handleLogoUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("logo", file);

        try {
            setLoading(true);
            const res = await axios.post(`${API_BASE_URL}/admin/logo`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            if (res.data.success) {
                const logo = res.data.logoUrl;
                setLogoUrl(logo.startsWith('http') ? logo : `${API_DOMAIN}${logo}`);
                toast.success("Logo updated successfully");
            }
        } catch (err) {
            toast.error("Logo upload failed");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleStampUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("stamp", file);

        try {
            setLoading(true);
            const res = await axios.post(`${API_BASE_URL}/admin/stamp`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            if (res.data.success) {
                const stamp = res.data.stampUrl;
                setStampUrl(stamp.startsWith('http') ? stamp : `${API_DOMAIN}${stamp}`);
                toast.success("Stamp updated successfully");
            }
        } catch (err) {
            toast.error("Stamp upload failed");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleSignatureUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
            setSignatureUrl(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const getTemplate = (type, data) => {
        const { name, email, role, date, joiningDate, salary, noticePeriod, probationPeriod, dailyAllowance, performanceAllowance, location } = data;

        switch (type) {
            case "Appraisal":
                return `EMPLOYMENT APPRAISAL LETTER

Date: ${date}

To:
${name}
Email: ${email}

Subject: Annual Performance Appraisal & Salary Revision

Dear ${name},

Following our recent performance review for the previous financial year, we are pleased to inform you that your contribution to Timely Health has been exemplary. We value your commitment and are delighted to reward your hard work.

REVISION DETAILS:
New Designation: ${role}
Revised CTC: ${salary}
Effective Date: [Specify Date]

We look forward to your continued growth and success with the organization. Keep up the excellent work!

Best Regards,

Management
Timely Health Group`;

            case "Warning":
                return `DISCIPLINARY WARNING LETTER

Date: ${date}

To:
${name}
Email: ${email}

Subject: Formal Warning Regarding [Performance/Conduct]

Dear ${name},

This letter serves as a formal warning regarding your recent [Performance/Conduct] issues observed between [Start Date] and [End Date]. Specifically, we have noted concerns regarding:

- [Issue 1: e.g., Recurring tardiness]
- [Issue 2: e.g., Delayed deliverables]

REQUIRED ACTIONS:
Please ensure immediate improvement in the areas mentioned above. Failure to do so may result in further disciplinary action, up to and including termination of employment.

We hope to see a positive change in your performance moving forward.

Best Regards,

Human Resources Department
Timely Health Group`;

            case "Termination":
                return `EMPLOYMENT TERMINATION NOTICE

Date: ${date}

To:
${name}
Email: ${email}

Subject: Notice of Termination of Employment

Dear ${name},

We regret to inform you that your employment with Timely Health is being terminated, effective [Effective Date], due to [Reason: e.g., Structural Redundancy / Performance Concerns].

FINAL SETTLEMENT:
Last Working Day:[Date]
Notice Period: [Details]
Outstanding Dues: To be settled within 45 days of the last working day.

Please return all company property (Laptop, ID Card, etc.) by your last working day to the HR department.

We wish you the best in your future endeavors.

Best Regards,

Head of Human Resources
Timely Health Group`;

            case "Agreement":
                return `EMPLOYMENT AGREEMENT - TERMS & CONDITIONS

Date: ${date}

BETWEEN:
Timely Health PVT LTD (The Company)
AND:
${name} (The Candidate)

1. CONFIDENTIALITY
The employee agrees to keep all company information, trade secrets, and client data strictly confidential during and after employment. This includes but is not limited to financial data, client lists, and internal processes.

2. INTELLECTUAL PROPERTY
Any work produced, developed, or conceived by the employee during the course of employment shall be the sole and exclusive property of the Company.

3. CODE OF CONDUCT
The employee shall adhere to the company's code of conduct, professional ethics, and internal policies as outlined in the Employee Handbook.

4. NON-COMPETE & NON-SOLICITATION
The employee agrees not to engage in any business that competes with the Company or solicit its clients/employees for a period of 12 months after termination.

5. TERMINATION NOTICE
Both parties agree to a notice period as specified in the Offer Letter for termination of this agreement.

Acceptance:
By signing and uploading this document, the candidate formally accepts the terms and conditions of employment with Timely Health.

Best Regards,

Legal Department
Timely Health Group`;

            default:
                return `Date: ${date}

To,

${name}

${location || "[Candidate Address]"}


${email}

Subject: Offer of Employment - ${role}


Dear ${name},
In reference to your last interview and subsequent discussion, we have the pleasure of offering you the appointment for the post of ${role} in our organization Timely Healthtech Private Limited. On ${joiningDate} you are to report to the HR Manager. You will be on probation for a period of ${probationPeriod || "One Year"} from joining Date. Your salary will be ${salary} (Consolidated Pay).

Read this offer letter carefully, sign with the date & return the duplicate copy of this letter to us as a token of your acceptance of the appointment.


Congratulations! Welcome to the team Timely Health,



Best Wishes.

Please Report at the address given above by 10 AM and please bring a copy of the following Testimonials/certificates at the time of reporting:


a) ID Proof (Aadhar/Ration card/Driving license/Passport/Election ID)
b) Xerox copies of all Educational Documents
c) Original certificates of your past experience, including certificate from your last employer
d) Please also bring 4 passport size photographs, which we required for our records

────────────────────────────────────────────────────────────────────────────────

Annexure A

1. Posting and Transfer
Your services are liable to be transferred, at the sole discretion of Management, in such other capacity as the company may determine, to any department / section, location, associate, sister concern or subsidiary, at any place in India or abroad, whether existing today or which may come up in future. In such a case, you will be governed by the terms and conditions of the service applicable at the new placement location.

2. Probation
That you will be on probation for a period of ${probationPeriod || "twelve months"}. The period of probation can be extended at the discretion of the Management and you will continue to be on probation till an order of confirmation has been issued in writing.

3. Full time employment
Your position is a whole time employment with the Company and you shall devote yourself exclusively to the business and interests of the company. You will not take up any other work for remuneration (part time or otherwise) or work in an advisory capacity, or be interested directly or indirectly (except as shareholder / debenture holder), in any other trade or business during your employment with the company, without permission in writing of the Management of the Company. You will also not seek membership of any local or public bodies without first obtaining specific permission from the Management.

4. Confidentiality
You will not share any information at any time, during the employment or after, without the consent of the Management disclose or divulge or make public, except on legal obligations, any information regarding the Company's affairs or administration or research carried out, whether the same is confided to you or becomes known to you in the course of your service or otherwise.

5. Intellectual Property
If you conceive any new or advanced method of improving designs/ processes/ formulae/ systems, etc. in relation to the business/ operations of the Company, such developments will be fully communicated to the company and will remain the sole right/ property of the Company.

6. Responsibilities & Duties
Your work in the organization will be subject to the rules and regulations of the organization as laid down in relation to conduct, discipline and other matters. You will always be alive to responsibilities and duties attached to your office and conduct yourself accordingly. You must effectively perform to ensure results.

7. Past Records
This letter of appointment is based on the information furnished in your application for employment and during the interviews you had with us. If any declaration given, or information furnished by you, to the company proves to be false, or if you are found to have willfully suppressed any material information, in such cases, you will be liable to removal from services without any notice.

8. Termination of employment
During the probationary period and any extension thereof, your services may be terminated without giving any notice or salary in lieu thereof. However, on confirmation, services can be terminated by either side by giving one month (30 days) notice or salary in lieu thereof. Upon resignation/termination, you will immediately hand over to the Company all correspondence, specifications, formulae, books, documents, market data, cost data, drawings, records, and property belonging to the Company or relating to its business, and shall not retain or make copies of these items. Services may also be terminated without payment of any compensation for: failure to perform duties, loss of confidence, fraud, insubordination, misconduct, moral turpitude, prejudicial acts, or breach of any terms of this appointment.

9. Authority
No authority is vested upon you to make any financial commitment and enter into agreements/contracts/understandings of any nature with any second party and third party without seeking the prior permission/approval of the management. Any violation to exceed your specified authority as mentioned will be seriously viewed and disciplinary/appropriate legal action will be taken.

Benefits and Allowances:
Daily Allowance: ${dailyAllowance || "NA"}
Performance allowances: ${performanceAllowance || "NA"}
Health Benefits: Free Doctor Consultations at our associate clinics/ Hospitals
Diagnostic/ Tests/ Health Check-ups:
a. Employee self:-up to 70% off on MRP.
b. Immediate Family members:- up to 40% of MRP.
c. Other Family members/ Relatives:- up to 30% of on MRP
Salary appraisal cycle: April/ 1st Month of Every financial year. Candidate minimum working days for participating in appraisal scheme is 120 days from the date of Joining.`;
        }
    };

    const fetchApplicationDetails = async () => {
        try {
            setFetching(true);
            let app = null;

            if (applicationId && applicationId !== "undefined") {
                const res = await axios.get(`${API_BASE_URL}/applications/get/${applicationId}`);
                if (res.data.success) app = res.data.application;
            }

            if (!app && candidateEmail) {
                const res = await axios.get(`${API_BASE_URL}/applications/all`);
                if (res.data.success) {
                    app = res.data.applications.find(a => a.email === candidateEmail);
                }
            }

            if (app) {
                setCandidate(app);
                if (app.documentsVerified) {
                    setDocsVerified({
                        resume: app.documentsVerified.resume || false,
                        idProof: app.documentsVerified.idProof || false,
                        academicCertificates: app.documentsVerified.academicCertificates || app.documentsVerified.educationalDocs || false,
                        experienceLetter: app.documentsVerified.experienceLetter || false,
                    });
                }

                const data = {
                    name: `${app.firstName} ${app.lastName}`,
                    email: app.email || "[Candidate Email]",
                    role: app.jobId?.role || "Team Member",
                    date: new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' }),
                    joiningDate: app.dateOfJoining ? new Date(app.dateOfJoining).toLocaleDateString() : "[To be discussed]",
                    salary: app.finalSalary ? `INR ${app.finalSalary}LPA` : (app.expectedCTC ? `INR ${app.expectedCTC}LPA` : "As per agreed terms"),
                    location: app.currentLocation || "Corporate Office",
                    noticePeriod: app.noticePeriod || "",
                    probationPeriod: app.probationPeriod || "",
                    dailyAllowance: app.dailyAllowance || "",
                    performanceAllowance: app.performanceAllowance || "",
                };

                const type = documentType || "Offer";
                setOfferContent(getTemplate(type, data));
            }
        } catch (err) {
            console.error(err);
            toast.error("Failed to fetch candidate details");
        } finally {
            setFetching(false);
        }
    };

    const getBase64ImageFromUrl = (imgUrl) => {
        return new Promise((resolve) => {
            if (!imgUrl) return resolve(null);
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                resolve({ dataUrl: canvas.toDataURL("image/png"), width: img.width, height: img.height });
            };
            img.onerror = () => resolve(null);
            img.src = imgUrl;
        });
    };

    const renderPDFContent = (doc, content, logoBase64, stampBase64, sigBase64) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 20;
        let currentY = 20;

        const FOOTER_HEIGHT = 22;
        const FOOTER_MARGIN = 0;

        const addAddressFooter = (doc, pageWidth, pageHeight) => {
            const footerY = pageHeight - FOOTER_HEIGHT - FOOTER_MARGIN;
            const footerX = 0;
            const footerW = pageWidth;

            doc.setFillColor(5, 176, 158);
            doc.rect(footerX, footerY, footerW, FOOTER_HEIGHT, 'F');

            doc.setFont("helvetica", "bold");
            doc.setFontSize(16);
            doc.setTextColor(255, 255, 255);
            doc.text("Timely Healthtech Private Limited", pageWidth / 2, footerY + 8.5, { align: "center" });

            doc.setFont("helvetica", "bold");
            doc.setFontSize(8.5);
            doc.setTextColor(255, 255, 255);
            const addressText = "Flat No:301, H.No:1-68/22, Plot No. 54 & 55, Sri Sai Balaji Avenue, Arunodaya Colony, Madhapur, Hyderabad, Telangana-500081";
            doc.text(addressText, pageWidth / 2, footerY + 14.5, { align: "center" });

            doc.setFont("helvetica", "bold");
            doc.setFontSize(11);
            doc.setTextColor(255, 255, 255);
            const contactText = "Mail: timelyglobal.in@gmail.com        Mobile: 90 1048 1048        www.timelyhealth.in";
            doc.text(contactText, pageWidth / 2, footerY + 20.5, { align: "center" });
        };

        // FIX: signature/stamp block ko footer ke aur paas laane ke liye height ghata di (55 -> 45)
        const SIGNATURE_BLOCK_HEIGHT = 45;

        const addText = (text, fontSize = 10, isBold = false, color = [30, 41, 59]) => {
            const isFirstPage = doc.internal.getCurrentPageInfo().pageNumber === 1;
            const bottomLimit = isFirstPage
                ? pageHeight - (FOOTER_HEIGHT + SIGNATURE_BLOCK_HEIGHT + 15)
                : pageHeight - (FOOTER_HEIGHT + 15);

            if (currentY > bottomLimit) {
                addAddressFooter(doc, pageWidth, pageHeight);
                doc.addPage();
                currentY = 20;
            }

            doc.setFontSize(fontSize);
            doc.setFont("helvetica", isBold ? "bold" : "normal");
            doc.setTextColor(color[0], color[1], color[2]);

            const lines = doc.splitTextToSize(text, pageWidth - (2 * margin));
            const lineStep = fontSize * 0.46;

            // FIX: multi-line paragraphs ab justify hote hain (last line chhod kar) taaki
            // right side bhi left side jaisa hi clean/straight dikhe, ragged na lage.
            if (lines.length > 1) {
                lines.forEach((ln, idx) => {
                    const isLastLine = idx === lines.length - 1;
                    const y = currentY + (idx * lineStep);
                    if (isLastLine) {
                        doc.text(ln, margin, y);
                    } else {
                        doc.text(ln, margin, y, {
                            maxWidth: pageWidth - (2 * margin),
                            align: 'justify'
                        });
                    }
                });
            } else {
                doc.text(lines, margin, currentY);
            }

            currentY += (lines.length * lineStep) + 1.2;
        };

        // ===== HEADER =====
        if (logoBase64 && logoBase64.dataUrl) {
            const ratio = logoBase64.width / logoBase64.height;
            const imgHeight = 15;
            const imgWidth = imgHeight * ratio;
            doc.addImage(logoBase64.dataUrl, "PNG", margin, currentY, imgWidth, imgHeight);
            currentY += imgHeight + 5;
        } else {
            doc.setFont("helvetica", "bold");
            doc.setFontSize(18);
            doc.setTextColor(63, 81, 181);
            doc.text("TIMELY HEALTH", margin, currentY + 10);
            currentY += 20;
        }

        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(63, 81, 181);
        doc.text(`${documentType.toUpperCase()} LETTER`, pageWidth - margin, currentY - 5, { align: "right" });

        // ===== BORDER LINE - HEADER KE NICHE =====
        doc.setDrawColor(226, 232, 240);
        doc.line(margin, currentY, pageWidth - margin, currentY);
        currentY += 10;

        // ===== CONTENT =====
        const lines = content.split('\n');
        let isPoint8Done = false;
        let isPoint9Started = false;
        let isDLineDone = false;
        let dearLineEndX = 90; // fallback width (mm) agar "Dear" line na mile

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            const trimmedLine = line.trim();

            if (trimmedLine === '') {
                currentY += 2;
                continue;
            }

            // ===== "d)" DETECT - ISKE BAAD LINE DAALO =====
            if (trimmedLine.startsWith('d)') && !isDLineDone) {
                addText(trimmedLine, 10, false, [30, 41, 59]);
                // LINE DAALO - "d)" ke neeche
                doc.setDrawColor(200, 200, 200);
                doc.line(margin, currentY + 3, pageWidth - margin, currentY + 3);
                currentY += 10;
                isDLineDone = true;
                continue;
            }

            // ===== POINT 8 DETECT =====
            if (trimmedLine.startsWith('8.') && !isPoint8Done) {
                isPoint8Done = true;
            }

            // ===== POINT 9 DETECT - FORCE NEW PAGE =====
            if (trimmedLine.startsWith('9.') && isPoint8Done) {
                addAddressFooter(doc, pageWidth, pageHeight);
                doc.addPage();
                currentY = 20;
                isPoint9Started = true;
            }

            if (trimmedLine === "Annexure A") {
                addAddressFooter(doc, pageWidth, pageHeight);
                doc.addPage();
                currentY = 20;

                doc.setFont("helvetica", "bold");
                doc.setFontSize(14);
                doc.setTextColor(30, 41, 59);
                doc.text("Annexure A", pageWidth / 2, currentY, { align: "center" });
                currentY += 10;
                continue;
            }

            if (trimmedLine.startsWith('Date:')) {
                doc.setFontSize(10);
                doc.setFont("helvetica", "normal");
                doc.setTextColor(30, 41, 59);
                doc.text(trimmedLine, pageWidth - margin, currentY, { align: "right" });
                currentY += 7;
                continue;
            }

            // "Dear Name," line ki width naapte hain taaki agli line usi comma ke
            // theek niche se shuru ho sake (chahe naam chhota ho ya bada)
            if (trimmedLine.startsWith('Dear ')) {
                doc.setFontSize(10);
                doc.setFont("helvetica", "normal");
                dearLineEndX = doc.getTextWidth(trimmedLine);
                addText(trimmedLine, 10, false, [30, 41, 59]);
                continue;
            }

            // FIX: sirf "In reference..." ki PEHLI line right shift hoti hai (comma ke niche
            // se), lekin wrap hone wali baaki lines normal margin par hi wapas aa jaati hain.
            // Extra line-height diya taaki wrapped lines a,b,c,d list jaisi airy dikhein,
            // clumsy/cramped na lagein.
            if (trimmedLine.startsWith('In reference to your last interview')) {
                doc.setFontSize(10);
                doc.setFont("helvetica", "normal");
                doc.setTextColor(30, 41, 59);
                const spaceWidth = doc.getTextWidth(" ");
                const numSpaces = Math.max(0, Math.round((dearLineEndX || 90) / spaceWidth));
                const indentedText = " ".repeat(numSpaces) + trimmedLine;

                const isFirstPage = doc.internal.getCurrentPageInfo().pageNumber === 1;
                const bottomLimit = isFirstPage
                    ? pageHeight - (FOOTER_HEIGHT + SIGNATURE_BLOCK_HEIGHT + 15)
                    : pageHeight - (FOOTER_HEIGHT + 15);
                if (currentY > bottomLimit) {
                    addAddressFooter(doc, pageWidth, pageHeight);
                    doc.addPage();
                    currentY = 20;
                }

                const wrapped = doc.splitTextToSize(indentedText, pageWidth - (2 * margin));
                const lineGap = 6.2; // normal ~4.6 tha, ab thoda zyada gap taaki lines airy dikhein
                // FIX: justify align use kiya taaki right side ki lines ragged/uneven na dikhein,
                // sab lines (aakhri line chhod kar) dono taraf se margin tak clean align ho jaayein.
                wrapped.forEach((ln, idx) => {
                    const isLastLine = idx === wrapped.length - 1;
                    if (isLastLine) {
                        doc.text(ln, margin, currentY + (idx * lineGap));
                    } else {
                        doc.text(ln, margin, currentY + (idx * lineGap), {
                            maxWidth: pageWidth - (2 * margin),
                            align: 'justify'
                        });
                    }
                });
                currentY += (wrapped.length * lineGap) + 1.2;
                continue;
            }

            if (trimmedLine.startsWith('###')) {
                const headingText = trimmedLine.replace(/^###\s*/, '');
                addText(headingText.toUpperCase(), 11, true, [37, 99, 235]);
                continue;
            }
            if (trimmedLine.startsWith('##')) {
                const headingText = trimmedLine.replace(/^##\s*/, '');
                addText(headingText, 13, true, [30, 41, 59]);
                continue;
            }
            if (trimmedLine.startsWith('#')) {
                const headingText = trimmedLine.replace(/^#\s*/, '');
                addText(headingText, 16, true, [30, 41, 59]);
                continue;
            }

            if (trimmedLine.startsWith('- ')) {
                const bulletText = trimmedLine.replace(/^-\s*/, '');
                doc.setFontSize(10);
                doc.setFont("helvetica", "normal");
                doc.setTextColor(30, 41, 59);
                const bulletLines = doc.splitTextToSize(`• ${bulletText}`, pageWidth - (2 * margin) - 10);
                doc.text(bulletLines, margin + 10, currentY);
                currentY += (bulletLines.length * 4.5) + 0.6;
                continue;
            }

            const numberedMatch = trimmedLine.match(/^(\d+)\.\s*(.*)/);
            if (numberedMatch) {
                const num = numberedMatch[1];
                const text = numberedMatch[2];
                doc.setFontSize(10);
                doc.setFont("helvetica", "normal");
                doc.setTextColor(30, 41, 59);
                const numberedLines = doc.splitTextToSize(`${num}. ${text}`, pageWidth - (2 * margin) - 10);
                doc.text(numberedLines, margin + 10, currentY);
                currentY += (numberedLines.length * 4.5) + 0.6;
                continue;
            }

            if (trimmedLine.match(/^[A-Z][a-z]+ [A-Z]$/)) {
                addText(trimmedLine, 12, true, [30, 41, 59]);
                continue;
            }

            if (trimmedLine.includes('**')) {
                const cleanLine = trimmedLine.replace(/\*\*/g, '');
                addText(cleanLine, 10, true, [30, 41, 59]);
            } else {
                if (!trimmedLine.includes('Timely Healthtech') &&
                    !trimmedLine.includes('Flat No:') &&
                    !trimmedLine.includes('Mail:') &&
                    !trimmedLine.includes('www.timelyhealth') &&
                    !trimmedLine.includes('────────────────')) {
                    addText(trimmedLine, 10, false, [30, 41, 59]);
                }
            }
        }

        // ===== SIGNATURE AND STAMP - PAGE 1 PAR =====
        doc.setPage(1);
        let sigY = pageHeight - (FOOTER_HEIGHT + SIGNATURE_BLOCK_HEIGHT);

        // CANDIDATE SIGNATURE - LINE HATAYI
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.setTextColor(30, 41, 59);
        doc.text("CANDIDATE SIGNATURE", margin, sigY + 34);

        const rightX = pageWidth - margin;
        if (stampBase64 && stampBase64.dataUrl) {
            const stampRatio = stampBase64.width / stampBase64.height;
            const stampHeight = 30;
            const stampWidth = stampHeight * stampRatio;
            const stampX = rightX - stampWidth - 5;
            doc.addImage(stampBase64.dataUrl, "PNG", stampX, sigY, stampWidth, stampHeight);

            const stampCenterX = stampX + (stampWidth / 2);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(7);
            doc.setTextColor(30, 41, 59);
            doc.text("HR MANAGER", stampCenterX, sigY + stampHeight + 5, { align: "center" });
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            doc.setTextColor(30, 41, 59);
            doc.text("Timely Healthtech Private Limited", stampCenterX, sigY + stampHeight + 10, { align: "center" });
        }

        if (sigBase64 && sigBase64.dataUrl) {
            const sigRatio = sigBase64.width / sigBase64.height;
            const sigImgHeight = 10;
            const sigImgWidth = sigImgHeight * sigRatio;
            const sigImgX = rightX - sigImgWidth - 5;
            const sigImgY = sigY + 3;
            doc.addImage(sigBase64.dataUrl, "PNG", sigImgX, sigImgY, sigImgWidth, sigImgHeight);
        }

        // Page 1 footer
        addAddressFooter(doc, pageWidth, pageHeight);

        // Har page par footer aur watermark
        const totalPages = doc.internal.getNumberOfPages();
        for (let p = 1; p <= totalPages; p++) {
            doc.setPage(p);

            if (p !== 1) {
                addAddressFooter(doc, pageWidth, pageHeight);
            }

            if (logoBase64 && logoBase64.dataUrl) {
                const wmRatio = logoBase64.width / logoBase64.height;
                const wmWidth = 100;
                const wmHeight = wmWidth / wmRatio;
                const wmX = (pageWidth - wmWidth) / 2;
                const wmY = (pageHeight - wmHeight) / 2;

                doc.saveGraphicsState();
                doc.setGState(new doc.GState({ opacity: 0.08 }));
                doc.addImage(logoBase64.dataUrl, "PNG", wmX, wmY, wmWidth, wmHeight);
                doc.restoreGraphicsState();
            }
        }

        return doc;
    };

    const generatePreviewPDF = async () => {
        try {
            setIsGeneratingPreview(true);

            const doc = new jsPDF();

            const [logoBase64, stampBase64, sigBase64] = await Promise.all([
                getBase64ImageFromUrl(logoUrl),
                getBase64ImageFromUrl(stampUrl),
                signatureUrl ? getBase64ImageFromUrl(signatureUrl) : Promise.resolve(null)
            ]);

            const fullDoc = renderPDFContent(doc, offerContent, logoBase64, stampBase64, sigBase64);

            const total = fullDoc.internal.getNumberOfPages();
            setTotalPages(total);

            const pdfBlob = fullDoc.output('blob');
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPreviewPdfUrl(pdfUrl);
            setCurrentPage(1);

            setIsGeneratingPreview(false);

        } catch (err) {
            console.error("Error generating preview:", err);
            setIsGeneratingPreview(false);
            toast.error("Failed to generate preview");
        }
    };

    const handleDownload = async () => {
        if (!offerContent) return toast.error("No content to download");

        try {
            setLoading(true);
            const doc = new jsPDF();

            const [logoBase64, stampBase64, sigBase64] = await Promise.all([
                getBase64ImageFromUrl(logoUrl),
                getBase64ImageFromUrl(stampUrl),
                signatureUrl ? getBase64ImageFromUrl(signatureUrl) : Promise.resolve(null)
            ]);

            renderPDFContent(doc, offerContent, logoBase64, stampBase64, sigBase64);

            doc.save(`${documentType}_Letter_${candidate?.firstName || "Candidate"}.pdf`);
            toast.success("Document downloaded successfully");
        } catch (err) {
            console.error("Download failed:", err);
            toast.error("Failed to generate PDF");
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = async () => {
        if (!offerContent) return toast.error("No content to print");

        try {
            setLoading(true);
            const doc = new jsPDF();

            const [logoBase64, stampBase64, sigBase64] = await Promise.all([
                getBase64ImageFromUrl(logoUrl),
                getBase64ImageFromUrl(stampUrl),
                signatureUrl ? getBase64ImageFromUrl(signatureUrl) : Promise.resolve(null)
            ]);

            renderPDFContent(doc, offerContent, logoBase64, stampBase64, sigBase64);

            doc.autoPrint();
            const blobUrl = doc.output('bloburl');
            window.open(blobUrl, '_blank');
        } catch (err) {
            console.error("Print failed:", err);
            toast.error("Failed to open print preview");
        } finally {
            setLoading(false);
        }
    };

    const handleSendOffer = async () => {
        const appId = applicationId || candidate?._id;
        if (!appId) return toast.error("No Application ID found");

        try {
            setLoading(true);

            if (documentType === "Agreement" || attachment) {
                const formData = new FormData();
                formData.append("applicationId", appId);
                formData.append("email", candidateEmail || candidate?.email);
                formData.append("agreementsContent", offerContent);
                formData.append("documentType", documentType);
                if (attachment) {
                    formData.append("adminAttachment", attachment);
                }

                const endpoint = documentType === "Agreement" ? "send-agreements" : "send-offer";
                const res = await axios.post(`${API_BASE_URL}/applications/${endpoint}`, formData, {
                    headers: { "Content-Type": "multipart/form-data" }
                });

                if (res.data.success) {
                    toast.success(`${documentType} dispatched successfully`);
                    navigate("/score");
                }
            } else {
                const res = await axios.post(`${API_BASE_URL}/applications/send-offer`, {
                    applicationId: appId,
                    email: candidateEmail || candidate?.email,
                    offerLetterContent: offerContent,
                    documentsVerified: docsVerified,
                    documentType: documentType
                });

                if (res.data.success) {
                    toast.success("Offer letter dispatched successfully");
                    navigate("/score");
                }
            }
        } catch (err) {
            toast.error("Dispatch Failed: " + (err.response?.data?.message || err.message));
        } finally {
            setLoading(false);
        }
    };

    if (fetching) return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="flex flex-col items-center gap-6">
                <div className="w-12 h-12 border-4 border-purple-600 border-t-transparent rounded-full animate-spin"></div>
                <div className="text-center">
                    <p className="text-base font-bold text-gray-800">Drafting Offer...</p>
                </div>
            </div>
        </div>
    );

    return (
        <div className="p-3 mx-auto bg-white rounded-lg shadow-md max-w-full min-h-screen">
            <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-4 mb-2 xl:flex-row xl:items-center xl:justify-between px-2">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => navigate(-1)}
                            className="flex items-center gap-2 px-3 py-2 text-sm font-bold text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors shadow-sm"
                        >
                            <FaChevronLeft className="text-xs" /> Back
                        </button>
                        <div>
                            <h1 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                                Dispatch Offer Letter
                            </h1>
                            <p className="text-gray-400 text-[10px] font-black mt-1 uppercase tracking-widest">
                                Professional Documentation Pipeline
                            </p>
                        </div>
                    </div>

                    {candidate && (
                        <div className="flex items-center gap-4 bg-gray-50 px-5 py-3 rounded-2xl border border-gray-100 shadow-sm">
                            <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-blue-600 rounded-xl flex items-center justify-center text-white text-lg font-black shadow-lg shadow-blue-100">
                                {candidate.firstName.charAt(0)}
                            </div>
                            <div className="flex flex-col">
                                <span className="text-sm font-bold text-gray-800 leading-tight">{candidate.firstName} {candidate.lastName}</span>
                                <span className="text-[10px] font-black text-blue-600 uppercase tracking-widest">{candidate.jobId?.role}</span>
                            </div>
                        </div>
                    )}
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 p-2">
                    <div className="lg:col-span-4 space-y-6">
                        <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm">
                            <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-5 flex items-center gap-2">
                                <FaFileAlt className="text-purple-500" /> Document Type
                            </h3>
                            <div className="space-y-2">
                                {["Offer", "Appraisal", "Warning", "Termination", "Agreement"].map((type) => (
                                    <button
                                        key={type}
                                        onClick={() => {
                                            if (window.confirm(`Switch to ${type} template? This will overwrite your current edits.`)) {
                                                setDocumentType(type);
                                                const data = {
                                                    name: `${candidate?.firstName} ${candidate?.lastName}`,
                                                    email: candidate?.email || "[Candidate Email]",
                                                    role: candidate?.jobId?.role || "Team Member",
                                                    date: new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' }),
                                                    joiningDate: candidate?.dateOfJoining ? new Date(candidate?.dateOfJoining).toLocaleDateString() : "[To be discussed]",
                                                    salary: candidate?.finalSalary ? `INR ${candidate?.finalSalary}LPA` : (candidate?.expectedCTC ? `INR ${candidate?.expectedCTC}LPA` : "As per agreed terms"),
                                                    location: candidate?.currentLocation || "Corporate Office",
                                                    noticePeriod: candidate?.noticePeriod || "",
                                                    probationPeriod: candidate?.probationPeriod || "",
                                                    dailyAllowance: candidate?.dailyAllowance || "",
                                                    performanceAllowance: candidate?.performanceAllowance || "",
                                                };
                                                setOfferContent(getTemplate(type, data));
                                            }
                                        }}
                                        className={`w-full text-left p-3 rounded-xl border transition-all text-[10px] font-black uppercase tracking-widest ${documentType === type ? 'bg-purple-50 border-purple-200 text-purple-700' : 'bg-gray-50 border-gray-100 text-gray-400 hover:bg-white hover:text-gray-600'}`}
                                    >
                                        {type} {type === "Agreement" ? "Docs" : "Letter"}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm">
                            <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-5 flex items-center gap-2">
                                <FaUpload className="text-emerald-500" /> Attachment (Optional)
                            </h3>
                            <div className="space-y-4">
                                <div className="relative border-2 border-dashed border-gray-100 rounded-xl p-4 flex flex-col items-center justify-center hover:bg-gray-50 transition-colors pointer-cursor">
                                    <input
                                        type="file"
                                        onChange={(e) => setAttachment(e.target.files[0])}
                                        className="absolute inset-0 opacity-0 cursor-pointer"
                                    />
                                    <FaCloudUploadAlt className={`text-2xl mb-2 ${attachment ? "text-emerald-500" : "text-gray-300"}`} />
                                    <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest text-center">
                                        {attachment ? attachment.name : "Upload PDF Attachment"}
                                    </p>
                                </div>
                                {attachment && (
                                    <button
                                        onClick={() => setAttachment(null)}
                                        className="w-full py-2 text-[8px] font-black text-rose-500 uppercase tracking-widest hover:bg-rose-50 rounded-lg transition-colors"
                                    >
                                        Remove Attachment
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm">
                            <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-5 flex items-center gap-2">
                                <FaImage className="text-blue-500" /> Company Branding
                            </h3>
                            <div className="space-y-6">
                                <div>
                                    <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-3">Company Logo</p>
                                    <div className="relative border-2 border-dashed border-gray-100 rounded-xl p-4 flex flex-col items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer group">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleLogoUpload}
                                            className="absolute inset-0 opacity-0 cursor-pointer"
                                        />
                                        <FaUpload className="text-xl mb-2 text-gray-300 group-hover:text-blue-500 transition-colors" />
                                        <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest text-center">
                                            Update Company Logo
                                        </p>
                                    </div>
                                    <div className="h-20 bg-gray-50 rounded-xl border border-gray-100 flex items-center justify-center p-3 mt-3">
                                        <img
                                            src={logoUrl}
                                            alt="Logo Preview"
                                            className="max-h-full max-w-full object-contain"
                                            onError={(e) => e.target.src = 'https://placehold.co/200x60/6366f1/ffffff?text=Timely+Health'}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-3 flex items-center gap-2">
                                        <FaStamp className="text-amber-500" /> Company Stamp
                                    </p>
                                    <div className="relative border-2 border-dashed border-gray-100 rounded-xl p-4 flex flex-col items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer group">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleStampUpload}
                                            className="absolute inset-0 opacity-0 cursor-pointer"
                                        />
                                        <FaUpload className="text-xl mb-2 text-gray-300 group-hover:text-amber-500 transition-colors" />
                                        <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest text-center">
                                            Update Company Stamp
                                        </p>
                                    </div>
                                    {stampUrl && (
                                        <div className="h-20 bg-gray-50 rounded-xl border border-gray-100 flex items-center justify-center p-3 mt-3">
                                            <img
                                                src={stampUrl}
                                                alt="Stamp Preview"
                                                className="max-h-full max-w-full object-contain"
                                            />
                                        </div>
                                    )}
                                </div>

                                <div>
                                    <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest mb-3 flex items-center gap-2">
                                        <FaStamp className="text-green-500" /> Authorized Signature
                                    </p>
                                    <div className="relative border-2 border-dashed border-gray-100 rounded-xl p-4 flex flex-col items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer group">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleSignatureUpload}
                                            className="absolute inset-0 opacity-0 cursor-pointer"
                                        />
                                        <FaUpload className="text-xl mb-2 text-gray-300 group-hover:text-green-500 transition-colors" />
                                        <p className="text-[9px] font-black text-gray-500 uppercase tracking-widest text-center">
                                            Upload Authorized Signature
                                        </p>
                                    </div>
                                    {signatureUrl && (
                                        <div className="h-28 bg-gray-50 rounded-xl border border-gray-100 flex items-center justify-center p-4 mt-3">
                                            <img
                                                src={signatureUrl}
                                                alt="Signature Preview"
                                                className="max-h-full max-w-full object-contain"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-8">
                        <div className="bg-white rounded-2xl border border-gray-100 shadow-lg overflow-hidden flex flex-col min-h-[750px]">
                            <div className="flex bg-gray-50/50 p-1.5 gap-1.5 border-b border-gray-100">
                                <button
                                    onClick={() => setIsPreview(false)}
                                    className={`flex-1 py-3 px-4 rounded-xl text-[10px] font-black uppercase tracking-[0.2em] transition-all ${!isPreview ? 'bg-white text-purple-600 shadow-sm border border-gray-100' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'}`}
                                >
                                    Template Editor
                                </button>
                                <button
                                    onClick={() => setIsPreview(true)}
                                    className={`flex-1 py-3 px-4 rounded-xl text-[10px] font-black uppercase tracking-[0.2em] transition-all ${isPreview ? 'bg-white text-blue-600 shadow-sm border border-gray-100' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'}`}
                                >
                                    Preview
                                </button>
                                <button
                                    onClick={handleDownload}
                                    disabled={loading}
                                    className="flex-1 py-3 px-4 rounded-xl text-[10px] font-black uppercase tracking-[0.2em] transition-all text-gray-400 hover:text-emerald-600 hover:bg-emerald-50 flex items-center justify-center gap-2 disabled:opacity-50"
                                >
                                    <FaDownload /> Download
                                </button>
                                <button
                                    onClick={handlePrint}
                                    disabled={loading}
                                    className="flex-1 py-3 px-4 rounded-xl text-[10px] font-black uppercase tracking-[0.2em] transition-all text-gray-400 hover:text-blue-600 hover:bg-blue-50 flex items-center justify-center gap-2 disabled:opacity-50"
                                >
                                    <FaPrint /> Print
                                </button>
                            </div>

                            <div className="flex-1 p-8 flex flex-col">
                                {isPreview ? (
                                    <div className="flex-1 flex flex-col bg-gray-100 rounded-xl overflow-hidden">
                                        <div className="flex-1 flex items-center justify-center p-4 bg-gray-100" style={{ minHeight: '600px' }}>
                                            <div className="bg-white shadow-2xl rounded-lg overflow-hidden w-full h-full" style={{ maxWidth: '900px' }}>
                                                {isGeneratingPreview ? (
                                                    <div className="flex items-center justify-center h-full">
                                                        <div className="flex flex-col items-center gap-4">
                                                            <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                                                            <p className="text-sm font-bold text-gray-600">Generating Preview...</p>
                                                        </div>
                                                    </div>
                                                ) : previewPdfUrl ? (
                                                    <iframe
                                                        ref={iframeRef}
                                                        src={previewPdfUrl}
                                                        className="w-full h-[600px] border-0"
                                                        title="PDF Preview"
                                                    />
                                                ) : (
                                                    <div className="flex items-center justify-center h-full">
                                                        <p className="text-sm font-bold text-gray-400">No preview available</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <textarea
                                        className="flex-1 w-full p-8 border border-gray-100 rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-500/5 focus:border-blue-300 transition-all font-mono text-[11px] leading-relaxed resize-none bg-gray-50/50 text-gray-600 shadow-inner"
                                        value={offerContent}
                                        onChange={(e) => setOfferContent(e.target.value)}
                                        placeholder="Draft the official offer content here..."
                                        style={{ minHeight: '500px' }}
                                    />
                                )}

                                <div className="mt-8 flex flex-col md:flex-row justify-between items-center gap-6 pt-8 border-t border-gray-50">
                                    <div className="flex items-center gap-4">
                                        <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-purple-500 to-blue-600 flex items-center justify-center shadow-lg shadow-purple-100">
                                            <FaRocket size={16} className="text-white animate-pulse" />
                                        </div>
                                        <div>
                                            <p className="text-[10px] font-black text-gray-800 uppercase tracking-widest">Validated Template</p>
                                            <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">Ready for secure dispatch</p>
                                        </div>
                                    </div>

                                    <button
                                        className={`w-full md:w-auto px-10 py-4 bg-blue-600 text-white rounded-xl font-bold text-xs uppercase tracking-widest hover:bg-blue-700 transition-all flex items-center justify-center gap-3 shadow-lg shadow-blue-100 disabled:opacity-50 disabled:pointer-events-none`}
                                        disabled={loading}
                                        onClick={handleSendOffer}
                                    >
                                        {loading ? "Transmitting..." : <><FaPaperPlane /> Dispatch {documentType}</>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SendOffer;